module.exports = __webpack_public_path__ + "static/media/text_file_icon.ab2ffa17.svg";